export default "__VITE_ASSET__ooGocfgo__"